(() => {
  if (window.KCPerformance) return;
  const script = document.currentScript;
  const context = {version: 1, page_type: script?.dataset.pageType || 'unknown', theme_id: script?.dataset.themeId || '', device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'};
  const debug = new URLSearchParams(location.search).get('kc_perf') === '1';
  const samples = [];
  let output;
  const now = () => performance.now();
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  };
  const record = (metric, duration, outcome = 'success', serviceDuration) => {
    if (!Number.isFinite(duration) || duration < 0) return;
    const data = {...context, metric, duration_ms: Math.round(duration), outcome};
    if (Number.isFinite(serviceDuration)) data.service_ms = Math.max(0, Math.round(serviceDuration));
    if (debug) {
      samples.push(data);
      if (samples.length > 100) samples.shift();
      if (!output) {
        output = document.createElement('script');
        output.type = 'application/json';
        output.id = 'kc-performance-results';
        document.head.append(output);
      }
      output.textContent = JSON.stringify(samples);
    }
    if (!debug && allowed()) {
      try { Promise.resolve(window.Shopify?.analytics?.publish('kurdelecim:performance', data)).catch(() => {}); } catch (_) {}
    }
  };
  window.KCPerformance = {
    now,
    start(metric) { return {metric, started: now(), done: false}; },
    finish(token, outcome, serviceStarted) {
      if (!token || token.done) return;
      token.done = true;
      const end = now();
      record(token.metric, end - token.started, outcome, serviceStarted == null ? undefined : end - serviceStarted);
    }
  };
  const category = target => {
    if (!target?.closest) return null;
    if (target.closest('[data-kc-quantity], .kc-card-quantity, [aria-label="Paket sayısı"]')) return 'quantity';
    if (target.closest('[data-kc-option], [data-color]')) return 'color';
    if (target.closest('kc-collection-navigation, [data-kc-load-more]')) return 'filter';
    if (target.closest('[data-add], .kc-pdp-add')) return 'add';
    if (target.closest('header, [id*="__header"]')) return 'menu';
    if (target.closest('.kc-cart-item, .kc-desktop-cart-reopen')) return 'cart';
    return null;
  };
  let interactionObserver;
  let interactions = new Map();
  const observeInteractions = () => {
    try {
      if (!PerformanceObserver.supportedEntryTypes?.includes('event')) return false;
      interactionObserver = new PerformanceObserver(list => collect(list.getEntries()));
      interactionObserver.observe({type: 'event', buffered: true, durationThreshold: 40});
      return true;
    } catch (_) { return false; }
  };
  const collect = entries => {
    for (const entry of entries) {
      const group = category(entry.target);
      if (!group || !entry.interactionId) continue;
      const previous = interactions.get(entry.interactionId);
      if (!previous || entry.duration > previous.duration) interactions.set(entry.interactionId, {group, duration: entry.duration, input: Math.max(0, entry.processingStart - entry.startTime), handler: Math.max(0, entry.processingEnd - entry.processingStart)});
      if (interactions.size > 100) interactions.delete(interactions.keys().next().value);
    }
    if (debug) flushInteractions();
  };
  const flushInteractions = () => {
    const worst = new Map();
    for (const value of interactions.values()) if (!worst.has(value.group) || worst.get(value.group).duration < value.duration) worst.set(value.group, value);
    interactions.clear();
    worst.forEach(value => {
      record('interaction_' + value.group, value.duration);
      record('input_delay_' + value.group, value.input);
      record('handler_' + value.group, value.handler);
    });
  };
  if (!observeInteractions()) {
    let count = 0;
    document.addEventListener('click', event => {
      const group = category(event.target);
      if (!group || count++ >= 100 || document.visibilityState === 'hidden') return;
      const started = now();
      requestAnimationFrame(() => setTimeout(() => {
        if (document.visibilityState !== 'hidden') record('frame_wait_' + group, now() - started);
      }, 0));
    }, {capture: true, passive: true});
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      if (interactionObserver) collect(interactionObserver.takeRecords());
      flushInteractions();
    }
  });
  addEventListener('pagehide', () => {
    if (interactionObserver) collect(interactionObserver.takeRecords());
    flushInteractions();
  });
  let lcp = 0;
  const observers = [];
  try {
    if (PerformanceObserver.supportedEntryTypes?.includes('largest-contentful-paint')) {
      const observer = new PerformanceObserver(list => { for (const entry of list.getEntries()) lcp = entry.startTime; });
      observer.observe({type: 'largest-contentful-paint', buffered: true});
      observers.push(observer);
    }
  } catch (_) {}
  let reported = false;
  const report = () => {
    if (reported) return;
    reported = true;
    observers.forEach(observer => {
      for (const entry of observer.takeRecords()) lcp = entry.startTime;
      observer.disconnect();
    });
    if (lcp) record('lcp', lcp);
  };
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') report(); });
  addEventListener('pagehide', report);
  addEventListener('pointerdown', report, {once: true, capture: true});
  addEventListener('keydown', report, {once: true, capture: true});
})();

